import OnboardingVideo from './OnboardingVideo';

export default OnboardingVideo;
